var _G;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import Svg, { G, Path } from "react-native-svg";
var SvgScoreCards = function SvgScoreCards(props) {
  return /*#__PURE__*/React.createElement(Svg, _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 30,
    height: 30,
    fill: "none",
    overflow: "visible",
    preserveAspectRatio: "none",
    style: {
      display: "block"
    },
    viewBox: "0 0 30 30"
  }, props), _G || (_G = /*#__PURE__*/React.createElement(G, {
    stroke: "#FFD766",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2.5
  }, /*#__PURE__*/React.createElement(Path, {
    d: "M16.25 3.75h-10a2.5 2.5 0 0 0-2.5 2.5V22.5a2.5 2.5 0 0 0 2.5 2.5h10a2.5 2.5 0 0 0 2.5-2.5V6.25a2.5 2.5 0 0 0-2.5-2.5"
  }), /*#__PURE__*/React.createElement(Path, {
    d: "m18.75 6.25 7.5 1.25-2.5 20-12.5-1.25"
  }))));
};
export default SvgScoreCards;